import React from 'react'
import Link from 'gatsby-link'
import classnames from 'classnames'
import { slide as Menu } from 'react-burger-menu'
import MediaQuery from 'react-responsive'

import logo from './logoIFSblackV2.png'
import styles from './index.module.css'

class Header extends React.Component {
  render() {
    const stylesBurger = {
      bmBurgerButton: {
        position: 'fixed',
        width: '30px',
        height: '30px',
        right: '50px',
        top: '14px',
        transform: 'scale(.8, .6)'
      },
      bmMenuWrap: {
        top: 0
      },
      bmBurgerBars: {
        background: '#4a4a4a',
      },
      bmCrossButton: {
        height: '22px',
        width: '22px',
        right: '53px',
        top: '18px',
      },
      bmCross: {
        // background: '#4a4a4a',
      },
      bmMenu: {
        background: '#fff',
        padding: '2.5em 1.5em 0',
        fontSize: '1.15em'
      },
      bmMorphShape: {
        fill: '#373a47'
      },
      bmItemList: {
        color: '#b8b7ad',
        padding: '0.8em'
      },
      bmOverlay: {
        background: 'rgba(0, 0, 0, 0.3)',
        left: 0,
        top: '60px',
      }
    }
    const active = {
      color: 'rgba(187,25,51,.84)',
      borderBottom: '3px solid rgba(187,25,51,.84)',
      paddingBottom: '4px'
    }
    return (
      <header className={styles.header}>

        <Link to="/" className={styles.brand} >
          <img className={styles.logo} src={logo} alt="iFeelsmart" />
        </Link>

        <MediaQuery query="(min-width: 993px)" >
          <nav className={styles.nav} >
            {/* <Link
              activeStyle={active}
              innerRef={(el) => { this.myLink = el }} className={styles.navlink} to="/"
            >
              Home
            </Link> */}
            <Link
              activeStyle={active}
              innerRef={(el) => { this.myLink = el }} className={styles.navlink} to="/products"
            >
              Products
            </Link>
            <Link
              activeStyle={active}
              innerRef={(el) => { this.myLink = el }} className={styles.navlink} to="/references"
            >
              References
            </Link>
            <Link
              activeStyle={active}
              innerRef={(el) => { this.myLink = el }} className={styles.navlink} to="/about"
            >
              About us
            </Link>
            {/* <Link
              activeStyle={active}
              innerRef={(el) => { this.myLink = el }} className={styles.navlink} to="/career"
            >
              Careers
            </Link> */}
          </nav>
        </MediaQuery>

        <MediaQuery query="(max-width: 992px)" >
          <Menu
            styles={stylesBurger}
            right
            customCrossIcon={<img src="https://cdn.onlinewebfonts.com/svg/img_391885.png" />}
          >
            {/* <a className={classnames(styles.navlink, styles.burgerLink)} href="/">Home</a> */}
            <a className={classnames(styles.navlink, styles.burgerLink)} href="/products">Products</a>
            <a className={classnames(styles.navlink, styles.burgerLink)} href="/references">References</a>
            <a className={classnames(styles.navlink, styles.burgerLink)} href="/about">About us</a>
            {/* <a className={classnames(styles.navlink, styles.burgerLink)} href="/">Careers</a> */}
          </Menu>
        </MediaQuery>

      </header >
    )
  }
}

export default Header



// WEBPACK FOOTER //
// ./src/components/Header/index.js